import { useId } from 'react';
import type { ReactNode } from 'react';

import { ModalBase } from './ModalBase.tsx';

type DialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  /** The consequence of the action, stated plainly. */
  description?: ReactNode;
  children?: ReactNode;
  /** Buttons. Put the confirming action last. */
  footer?: ReactNode;
  dismissible?: boolean;
};

export function Dialog({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  dismissible = true,
}: DialogProps) {
  const titleId = useId();

  return (
    <ModalBase open={open} onClose={onClose} dismissible={dismissible} className="m-auto w-full">
      <div
        role="document"
        aria-labelledby={titleId}
        className="mx-auto w-[min(28rem,calc(100dvw-2rem))] rounded-lg border border-line bg-surface shadow-lg"
      >
        <div className="flex flex-col gap-2 p-5">
          <h2 id={titleId} className="text-lg font-strong">
            {title}
          </h2>
          {description === undefined ? null : (
            <div className="text-sm text-muted">{description}</div>
          )}
          {children}
        </div>
        {footer === undefined ? null : (
          <div className="flex justify-end gap-2 border-t border-line px-5 py-3">{footer}</div>
        )}
      </div>
    </ModalBase>
  );
}
